import React, { useState } from 'react'
import { Form, Input, Button, Divider } from 'antd'
import { Link, useNavigate } from 'react-router-dom'
import {
  FormContainer,
  FormWrapper,
  FormTitle,
  PageContainer
} from '../Login/style'
import { forgotPassword } from '../../reducers/authReducer'
import { useDispatch } from 'react-redux'

const ForgetPassword = () => {
  const [form] = Form.useForm()
  const nav = useNavigate()
   const dispatch = useDispatch()
   const [loading, setLoading] = useState(false)
   

  const handleRegister = () => {
    nav('/register')
  }

  const onFinish = async (values) => {
    setLoading(true)
    const result = await dispatch(forgotPassword(values.email))
    if (result.success) {
      setLoading(false)
      nav('/login')
    } else {
      setLoading(false)
    }
  }

  return (
    <PageContainer>
      <FormContainer>
        <FormWrapper>
          <FormTitle>Forgot Password</FormTitle>

          <div
            style={{ marginBottom: '20px', marginTop: '20px', color: '#555' }}
          >
            <span style={{ fontSize: '14px' }}>
              Enter your registered email to receive reset instructions.
            </span>
          </div>

          <Form
            form={form}
            name="forgetPassword"
            onFinish={onFinish}
            layout="vertical"
          >
            <Form.Item
              name="email"
              label="Email"
              rules={[
                {
                  type: 'email',
                  message: 'Please enter a valid email'
                },
                {
                  required: true,
                  message: 'Please enter your email'
                }
              ]}
            >
              <Input placeholder="Enter your valid email" />
            </Form.Item>

            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                block
                style={{ borderRadius: '6px' }}
                loading={loading}
              >
                Send Mail
              </Button>
            </Form.Item>
          </Form>

          <Divider plain>Or</Divider>
          <Form.Item>
            <Button
              block
              onClick={handleRegister}
              style={{
                borderRadius: '6px',
                backgroundColor: '#fefefe',
                color: '#1677ff',
                boxShadow: '0 0 12px 3px rgba(0, 0, 0, 0.08)'
              }}
            >
              Create Account
            </Button>
          </Form.Item>
        </FormWrapper>
      </FormContainer>
    </PageContainer>
  )
}

export default ForgetPassword
